// components
import { Button } from "../../UI";
import { Paragraph } from "../../typography";
// icons
import { Trash } from "../../../SVGS";
// builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";
// styles
import styled from "styled-components";

const StaffManagementItemStyles = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  .name {
    flex: 1;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    padding-right: ${({ theme }) => theme.spacing[24]};
  }

  .role {
    width: 190px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .contact {
    width: 190px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .email {
    width: 240px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .actions {
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;

    .deleteButton {
      height: 39px;
    }

    .deleteButton:hover path {
      fill: ${({ theme }) => theme.colors.semantic.container.white};
    }
  }
`;

const StaffManagementItem = ({
  editAction,
  deleteAction,
  firstName,
  lastName,
  roles,
  contactNumber,
  email
}) => {
  return (
    <StaffManagementItemStyles onClick={editAction}>
      <Paragraph className="name">{`${firstName} ${lastName}`}</Paragraph>
      <Paragraph className="role">
        {roles.length > 0 ? roles[0].name : ""}
      </Paragraph>
      <Paragraph className="contact">{contactNumber}</Paragraph>
      <Paragraph className="email">{email}</Paragraph>
      <div className="actions">
        <Button
          onClick={e => {
            e.stopPropagation();
            deleteAction();
          }}
          className="deleteButton"
          buttonDesignType={buttonDesignType.DANGER}
        >
          <Trash />
        </Button>
      </div>
    </StaffManagementItemStyles>
  );
};

export default StaffManagementItem;
